import React from 'react';
import { safeHTML } from '../../../utils/safeHTML';
import { useTranslation } from '../../../translations';

const Description = React.forwardRef(function Description({ description }, ref) {
  const { t } = useTranslation();
  return <h2 className={'w-modal__description'}>{safeHTML(t(description))}</h2>;
});
export default Description;
Description.propTypes = {};
